// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-list-box-multi-select-row.bolt-list-row.selected {
  background: transparent;
}
.bolt-list-box-multi-select-row.bolt-list-row.selected:hover {
  background: rgba(0, 0, 0, .02);
  background: var(--component-grid-row-hover-color,rgba(0, 0, 0, .02));
}
@media (forced-colors: active) {
  .bolt-list-box-multi-select-row.bolt-list-row.selected {
    background: transparent;
  }
}

.bolt-list-box-header-row {
  font-weight: 600;
  cursor: text;
}
.bolt-list-box-header-row.bolt-list-row:hover {
  background: transparent;
}

.bolt-list-box-text .bolt-table-cell-content {
  padding: 5px 0;
}

.bolt-list-box-text-single-select.bolt-list-cell {
  padding: 0 12px;
}

.bolt-list-box-text-multi-select {
  padding-right: 12px;
}

.bolt-list-box-divider-multi-select {
  padding-left: 12px;
}

.bolt-list-box-divider-row,
.bolt-list-box-loading-row {
  cursor: text;
}
.bolt-list-box-divider-row.bolt-list-row:hover,
.bolt-list-box-loading-row.bolt-list-row:hover {
  background: transparent;
}

.bolt-list-box-divider {
  margin-bottom: 1px;
  background-color: rgba(0, 0, 0, 0.10);
  background-color: var(--palette-black-alpha-10,rgba(0, 0, 0, 0.10));
  height: 1px;
}

.bolt-focus-visible .bolt-table.bolt-list-box .bolt-list-row:focus .bolt-list-cell {
  border-color: transparent;
}

.bolt-list-box-loading {
  padding: 8px 0px;
}
.bolt-list-box-loading .bolt-spinner {
  flex-direction: row;
}
.bolt-list-box-loading .bolt-spinner-circle {
  margin-right: 10px;
}
.bolt-list-box-loading .bolt-spinner-label {
  margin-top: 0px;
}

.bolt-list-row.bolt-list-box-item-disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
}
@media (forced-colors: active) {
  .bolt-list-row.bolt-list-box-item-disabled {
    color: graytext;
  }
}

.bolt-list-row.bolt-list-box-item-disabled:hover {
  background: transparent;
  cursor: text;
}

.bolt-list-box-cell-container {
  width: 100%;
}

@media (forced-colors: active) {
  .bolt-focus-visible .bolt-list-box-row:focus {
    font-weight: bold;
    color: highlight;
  }
  .bolt-focus-visible .bolt-list-box-row:focus .bolt-table-cell-select,
  .bolt-focus-visible .bolt-list-box-row:focus .bolt-list-box-text:not(.bolt-list-box-text-multi-select) {
    border-left: 2px solid highlight;
  }
  .bolt-focus-visible .bolt-list-box-row:focus .bolt-list-box-text {
    border-right: 2px solid highlight;
  }
}

@media (forced-colors: active) {
  .bolt-list-box-row .bolt-table-cell-select,
  .bolt-list-box-row .bolt-list-box-text:not(.bolt-list-box-text-multi-select) {
    border-left: 2px solid transparent;
  }
  .bolt-list-box-row .bolt-list-box-text {
    border-right: 2px solid transparent;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-box-row:hover, body.ms-vss-web-vsts-theme-hc-dark .bolt-list-box-row:focus {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-box-row:hover, body.ms-vss-web-vsts-theme-hc-light .bolt-list-box-row:focus {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}

@media (forced-colors: active) {
  .bolt-list-box {
    border: 1px solid windowText;
  }
}

.dropdown-list .checkmark-icon {
  padding: 0 6px;
}
.dropdown-list .bolt-header-cell {
  width: auto !important;
  min-width: 20px !important;
}

/*# sourceMappingURL=ListBox.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ListBox/ListBox.scss","webpack://./../azure-devops-ui/bin/Components/ListBox/ListBox.css","webpack://./../azure-devops-ui/src/_widgetsCommon.scss","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAGA;EACI,uBAAA;ACFJ;ADII;EACI,8BENe;EDIrB,oEAAoE;AE0ClE;AFxCJ;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EDII,gBAAA;ECFF,YAAY;ADIV;ACFJ;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;ADKA;;ECDE,YAAY;ADKV;AAAA;;ECDF,uBAAuB;AACzB;;AAEA;EDKI,kBIsEe;EJrEf,qCAAA;ECHF,mEAAmE;EACnE,WAAW;ADKb;;ACFA;EACE,yBAAyB;ADK3B;;ACFA;EDKI,gBAAA;ACHJ;AACA;EDMI,mBAAA;ACJJ;AACA;EDOI,kBAAA;ACLJ;AACA;EACE,eAAe;ADQjB;;ACLA;EEvBI,yBAAA;EH4BJ,oDAAA;ACFA;AACA;EACE;IACE,eAAe;EDOnB;ACLA;;AAEA;EACE,uBAAuB;EDOzB,YAAA;ACLA;;AAEA;EEtCI,WAAA;AFwCJ;;AAEA;EACE;IDOM,iBAAA;IAAA,gBAAA;ECJN;EACA;;IDSU,gCAAA;ECNV;EACA;IACE,iCAAiC;EEpDjC;AFsDJ;;AAEA;EACE;;IDYU,kCAAA;ECTV;EACA;IG0RM,mCAAA;EJ3QI;ACZZ;AACA;EGyRQ,sCAAA;EJ9QI,gEGxHS;EHyHT,6BI6BM;EHrChB,qDAAqD;AACvD;AEtEI;EHkFJ,sCAAA;ECTE,gEDWM;ECVN,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE;IDaE,4BAAA;EACI;ACXR;;AAEA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,sCAAsC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
